import React from 'react'

import { Collapse } from 'antd'

import type { LntCollapsePanelProps } from './types'

export const LntCollapsePanel: React.FC<LntCollapsePanelProps> = props => {
  const { children, ...restProps } = props

  return <Collapse.Panel { ...restProps }>{ children }</Collapse.Panel>
}
